import { Component, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import {
    LazadaOpenService,
    LexDocService,
    ShopeeOpenServiceV2,
} from 'src/app/shared/services';
import {
    lazadaStoreProviders,
    shopeeStoreProviders,
} from 'src/app/shared/config/store-config';
import { LazadaOrdersComponent } from '../../../shared/components/lazada-orders/lazada-orders.component';
import { ShopeeOrdersComponent } from '../../../shared/components/shopee-orders/shopee-orders.component';

@Component({
    selector: 'app-quick-orders',
    templateUrl: './quick-orders.component.html',
    styleUrls: ['./quick-orders.component.scss'],
    providers: [
        ...shopeeStoreProviders('shopee-general4'),
        ...lazadaStoreProviders('lazada-genlogic'),
        ShopeeOpenServiceV2,
        LazadaOpenService,
        LexDocService,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        LazadaOrdersComponent,
        ShopeeOrdersComponent,
        forwardRef(() => ShopeeGenlogicWrapperComponent),
    ],
})
export class QuickOrdersComponent {
    constructor() {}
}

@Component({
    selector: 'app-shopee-genlogic-orders-wrapper',
    template:
        '<app-shopee-orders title="Shopee (genlogic)"></app-shopee-orders>',
    providers: [
        ...shopeeStoreProviders('shopee-genlogic'),
        ShopeeOpenServiceV2,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ShopeeOrdersComponent],
})
export class ShopeeGenlogicWrapperComponent {
    constructor() {}
}
